<div class="container">

    <kal-icon class="left" (click)="previousInterval()">chevron_left</kal-icon>
    <kal-icon class="right" (click)="nextInterval()">chevron_right</kal-icon>
    <div class="view"
         #viewDiv
         [style]="'--timeslot-size: ' + timeslotSize + 'px; --viewportsize: calc( var(--timeslot-size)* ' + numberOfTimeslotsByDay * numberOfDays + ')'">
        <section
            [style]="'--timeline-day-size: calc( var(--timeslot-size)* ' + numberOfTimeslotsByDay + ')'"
            [style.width]="'var(--viewportsize)'">

            <!--
            en fonction du type de vue (mensuelle, hebdomadaire, journalière,
            on va calculer des intervals de temps à afficher
            chacun de ces intervals dispose
                d'un titre,
                d'une date de début et d'une date de fin
                de la capacité de naviguer de la précédente à la suivante
                le nombre de "division horaire" à afficher
            -->

            <!-- liste des intervals -->
            <div class="intervalsRow">
                <div class="interval"
                     *ngFor="let interval of intervalsList"
                     [style.flex]="'0 0 calc(var(--timeslot-size)* ' + interval.slot *  interval.days +')'">
                    <span [ngSwitch]="viewType">
                        <ng-container *ngSwitchCase="'days'">
                            {{ interval.start.toDate() | date: 'EEEE dd/MM'}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'weeks'">
                           Semaine du {{ interval.start.toDate() | date: 'dd/MM'}}
                            au {{ interval.end.toDate() | date: 'dd/MM'}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'months'">
                            {{ interval.start.toDate() | date: 'MMMM yyyy'}}
                        </ng-container>
                    </span>
                </div>
            </div>

            <!-- liste des heures -->
            <div class="hoursRow">
                <ng-container
                    *ngFor="let date of getDaysList()">
                    <div class="day" *ngIf="viewType !== 'days'">{{ date.toDate() | date: 'dd/MM' }}</div>
                    <div class="hours">
                        <div
                            *ngFor="let date of getTimeSlots(date)"
                            [class.weekend]="isEndOfWeek(date)">
                            {{ date.toDate() | date: 'HH:mm'}}
                        </div>
                    </div>
                </ng-container>
            </div>


            <!-- liste des timelines -->
            <div *ngFor="let timeline of timelinesList"
                 class="timeline"
                 (dblclick)="selectTimeline(timeline, $event)">

                <div class="title">
                    <span
                        (dblclick)="noop($event)"
                        (click)="selectLabel(timeline, $event)">
                        {{ timeline.label }}
                    </span>
                </div>

                <article>
                    <div class="row" *ngFor="let spotsRow of timeline.rowsList; let index=index">
                        <div class="spot"
                             *ngFor="let spot of spotsRow"
                             (dblclick)="noop($event)"
                             (click)="select(spot, $event)"
                             [style.width]="'calc(var(--timeline-day-size)* ' + getSpotWidth(spot) +')'"
                             [style.left]="'calc(var(--timeline-day-size)* ' + getSpotPosition(spot) +')'"
                             [ngClass]="spot.classes || []"
                             [class.selected]="spot === selected"
                             title="{{ spot.label }} de {{ spot.from.toDate()|date: 'dd/MM HH:mm'}} à {{ spot.to.toDate()|date: 'dd/MM HH:mm'}}">
                            {{ spot.label }}
                        </div>

                    </div>

                </article>

            </div>

        </section>
    </div>
</div>

